import { loadScript } from './load_script'

export function loadStripe() {
  return loadScript('https://js.stripe.com/v2/').then(function() {
    const stripeKeyElement = document.getElementById('credit_card_form')
    if (stripeKeyElement && stripeKeyElement.dataset.stripeKey) {
      Stripe.setPublishableKey(stripeKeyElement.dataset.stripeKey)
    } else {
      console.error('Stripe Publishable Key nicht im data-Attribut des Formulars gefunden!')
    }
  })
}
